export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "name": "Наставничество и развитие сотрудников: как руководителю развивать команду",
        "description": "Наставничество и развитие сотрудников: обучение руководителей передаче опыта, развитию подчинённых, кадровому резерву и самостоятельности команды. Корпоративные программы.",
        "url": "https://business-training.by/menedzhment-i-liderstvo/nastavnichestvo-i-razvitie-sotrudnikov",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Business Training",
          "url": "https://business-training.by"
        }
      },
      {
        "@type": "Service",
        "name": "Наставничество и развитие сотрудников",
        "description": "Корпоративные программы развития навыков наставничества и развития сотрудников: передача опыта, постановка развивающих задач, обратная связь, формирование самостоятельности команды и подготовка кадрового резерва. Диагностика, обучение, практика, внедрение и сопровождение.",
        "provider": {
          "@type": "Person",
          "name": "Алексей Сивко",
          "jobTitle": "Бизнес-тренер, консультант, фасилитатор, сертифицированный коуч ICU",
          "url": "https://business-training.by/o-trenere",
          "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
        },
        "areaServed": [
          { "@type": "Country", "name": "Беларусь" },
          { "@type": "Country", "name": "Россия" },
          { "@type": "Country", "name": "Казахстан" },
          { "@type": "Country", "name": "Израиль" }
        ],
        "serviceType": "наставничество, развитие сотрудников, обучение наставников, подготовка кадрового резерва, развитие персонала",
        "url": "https://business-training.by/menedzhment-i-liderstvo/nastavnichestvo-i-razvitie-sotrudnikov"
      },
      {
        "@type": "Person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер",
        "description": "18+ лет практики в корпоративном обучении. 100+ корпоративных проектов, 450+ тренингов и бизнес-сессий, 4500+ участников. Средняя оценка участников — 9,09/10. Работал с компаниями Беларуси, России, Казахстана и Израиля.",
        "url": "https://business-training.by/o-trenere",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Что такое наставничество сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Это процесс, в котором более опытный сотрудник или руководитель помогает менее опытному развивать профессиональные навыки и самостоятельность. Цель — не передать готовые ответы, а помочь сотруднику научиться самостоятельно решать рабочие задачи и брать ответственность за результат."
            }
          },
          {
            "@type": "Question",
            "name": "Чем наставничество отличается от обучения?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Обучение — это передача знаний и навыков, чаще в рамках тренинга или курса. Наставничество — длительный процесс сопровождения в рабочей практике: постановка развивающих задач, наблюдение, обратная связь и постепенная передача ответственности. Они дополняют друг друга, но решают разные задачи."
            }
          },
          {
            "@type": "Question",
            "name": "Какие навыки нужны наставнику?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Умение объяснять, наблюдать и видеть причины ошибок, задавать вопросы вместо выдачи готовых ответов, давать обратную связь, ставить развивающие задачи, сохранять терпение, контролировать прогресс и постепенно передавать ответственность. Это отдельная компетенция, которую нужно развивать."
            }
          },
          {
            "@type": "Question",
            "name": "Как руководителю развивать сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Через развивающие задачи немного выше текущего уровня, делегирование, совместный разбор ситуаций, наблюдение, обратную связь и разбор ошибок. Развитие эффективнее, когда встроено в рабочий процесс, а не происходит только на обучении."
            }
          },
          {
            "@type": "Question",
            "name": "Как правильно передавать опыт сотрудникам?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Не просто показать свой способ работы, а выстроить последовательность: определить цель, показать стандарт, дать попробовать, наблюдать, дать обратную связь, повторить и постепенно увеличивать самостоятельность. Главное — не забирать задачу обратно при первой ошибке."
            }
          },
          {
            "@type": "Question",
            "name": "Как развивать самостоятельность сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Постепенно уменьшать объём контроля и передавать ответственность. Сотрудник должен получать задачи, где он сам принимает решения и отвечает за результат. Если руководитель постоянно решает проблемы за сотрудника, команда не становится самостоятельнее."
            }
          },
          {
            "@type": "Question",
            "name": "Как наставничество связано с кадровым резервом?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Кадровый резерв — это не просто список перспективных сотрудников. Чтобы из специалиста вырос руководитель, нужны условия: сложные задачи, развитие ответственности, передача функций, возможность принимать решения и подготовка управленческих навыков. Наставничество создаёт эти условия."
            }
          },
          {
            "@type": "Question",
            "name": "Как подготовить сотрудников к руководящим должностям?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Через постепенную передачу управленческих функций: участие в принятии решений, взаимодействие с другими подразделениями, развитие коммуникации и обратной связи. Подготовка к руководящей роли — это системный процесс, а не разовое назначение."
            }
          },
          {
            "@type": "Question",
            "name": "Как обучить руководителей навыкам наставничества?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Через практическую программу: роль наставника, алгоритм передачи опыта, постановка развивающих задач, наблюдение, обратная связь, работа с ошибками и развитие самостоятельности. Содержание адаптируется под компанию и конкретные ситуации участников."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли разработать программу наставничества под конкретную компанию?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, адаптация — обязательный этап. Программа подстраивается под отрасль, структуру компании, уровень наставников и реальные ситуации развития сотрудников. Сначала проводится диагностика задач, затем настраивается содержание."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли обучать наставников онлайн?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, обучение проводится как очно в Минске и Беларуси, так и онлайн. Формат подбирается под задачу: тренинг для наставников, тренинг для руководителей, модульная программа, бизнес-игры, коучинг или сопровождение."
            }
          },
          {
            "@type": "Question",
            "name": "Что делать, если наставник постоянно делает работу за сотрудника?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Это типичная ошибка «проще сделать самому». Вместо исправления ошибки за сотрудника наставник должен наблюдать, задавать вопросы и давать обратную связь, чтобы сотрудник понял, что именно сделал неправильно. Иначе ситуация повторяется, а сотрудник остаётся зависимым."
            }
          },
          {
            "@type": "Question",
            "name": "Как оценивать эффективность наставничества?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Через изменения в работе сотрудника: выросла ли самостоятельность, снизилось ли количество повторяющихся ошибок, сократилось ли время выхода новых сотрудников на эффективность. Оцениваются изменения в поведении, а не обещаются гарантированные финансовые показатели."
            }
          },
          {
            "@type": "Question",
            "name": "Чем наставничество отличается от адаптации сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Адаптация помогает новому сотруднику войти в компанию и освоиться в должности. Наставничество развивает профессиональные навыки и самостоятельность. Они могут работать вместе, но это разные процессы: адаптация — про вхождение, наставничество — про развитие."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}